
import { Badge } from "@/components/ui/badge";

interface MessageStatusBadgeProps {
  status?: string;
}

const MessageStatusBadge = ({ status }: MessageStatusBadgeProps) => {
  if (!status) return null;
  
  return (
    <Badge 
      variant="outline" 
      className="ml-1 text-xs py-0 px-1.5"
    >
      {status}
    </Badge>
  );
};

export default MessageStatusBadge;
